import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class EstatePaymentStatus extends Enum {
  key!: string;
  value!: string;
  color!: string;

  static UNPAID: EstatePaymentStatus = {
    key: 'unpaid',
    get value() {
      return Lang.t('estate.unpaid');
    },
    color: '#F97068'
  };

  static PAID: EstatePaymentStatus = {
    key: 'paid',
    get value() {
      return Lang.t('estate.paid');
    },
    color: '#60C49D'
  };

  static PAID_SAAS: EstatePaymentStatus = {
    key: 'paid_saas',
    get value() {
      return Lang.t('estate.paid-saas');
    },
    color: '#60C49D'
  };
}
